import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AumicoStyleOptions } from '@modeso/types__aumico-lib-core-be';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ham-styling-menu',
    templateUrl: './ham-styling-menu.component.html',
    styleUrls: ['./ham-styling-menu.component.scss'],
})
export class HamStylingMenuComponent {
    hamStyles = AumicoStyleOptions;

    @Input() activeStyles: Record<AumicoStyleOptions, { enabled: boolean; appliedAt: Date }>;

    @Output() styleSelected = new EventEmitter<AumicoStyleOptions>();

    applyStyle(style: AumicoStyleOptions) {
        this.styleSelected.emit(style);
    }

    isStyleActive(style: AumicoStyleOptions): boolean {
        return this.activeStyles[style]?.enabled ?? false;
    }
}
